import supercluster from 'points-cluster';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import withPropsOnChange from 'recompose/withPropsOnChange';

const usaCoardinates = {
  lat: 36.778259,
  lng: -119.417931,
};

export const GMapHOC = compose(
  defaultProps({
    clusterRadius: 60,
    defaultStyle: {
      position: 'relative'
    },
    hoverDistance: 30,
    options: {
      maxZoom: 15,
      minZoom: 1,
    },
  }),
  withState(
    'hoveredMarkerId',
    'setHoveredMarkerId',
    -1,
  ),
  withState(
    'mapProps',
    'setMapProps',
    {
      center: usaCoardinates,
      zoom: 3,
    },
  ),
  // describe events
  withHandlers({
    onChange: ({ setMapProps }) => ({
      center, zoom, bounds,
    }) => {
      setMapProps({
        bounds,
        center,
        zoom,
      });
    },

    onChildMouseEnter: ({ setHoveredMarkerId }) => (hoverKey, { id }) => {
      setHoveredMarkerId(id);
    },

    onChildMouseLeave: ({ setHoveredMarkerId }) => (/* hoverKey, childProps */) => {
      setHoveredMarkerId(-1);
    },
  }),
  // precalculate clusters if markers data has changed
  withPropsOnChange(
    ['markers'],
    ({
      markers, clusterRadius, options: { minZoom, maxZoom },
    }) => ({
      getCluster: supercluster(
        markers,
        {
          maxZoom, // max zoom level to cluster the points on
          minZoom, // min zoom to generate clusters on
          radius: clusterRadius, // cluster radius in pixels
        },
      ),
    }),
  ),
  // get clusters specific for current bounds and zoom
  withPropsOnChange(
    ['mapProps', 'getCluster'],
    ({ mapProps, getCluster }) => ({
      clusters: mapProps.bounds
        ? getCluster(mapProps)
          .map(({
            wx, wy, numPoints, points,
          }) => ({
            lat: wy,
            lng: wx,
            markerId: `${numPoints}_${points[0].id}`,
            numPoints,
            text: numPoints,
          }))
        : [],
    }),
  ),
  // set hovered
  withPropsOnChange(
    ['clusters', 'hoveredMarkerId'],
    ({ clusters, hoveredMarkerId }) => ({
      clusters: clusters
        .map(({ id, ...cluster }) => ({
          ...cluster,
          hovered: id === hoveredMarkerId,
        })),
    }),
  ),
);
